export default {
  metaTitle: '店铺推荐商品',
  pageTitle: '店铺推荐商品',
  recommendedList: '推荐商品列表',
  placeholder1: '请填写商品Listing编号。如果推荐多个商品，可以通过在不同Lisiting编号之间插入英文逗号来实现批量填写。例如：10003993,1000482,10007644',
  save: '保存',
  content1: '商品id错误，请正确输入',
  error1: '请使用英文逗号',
  error2: '商品id不能超过16位，其值应该是数字不含逗号和空格',
  columnListing1: 'Listing ID',
  columnListing2: '标题',
  columnListing3: '最低商品价',
  columnListing4: '最高商品价',
  columnListing5: 'SKU数',
  columnListing6: '状态',
  columnListing7: '重量',
  columnListing8: '操作',
  status1: '下架',
  status2: '上架',
  remove: '移除'
}
